<template>
  <div>
    <div class="question-overlay question-overlay--left">
      <!-- Preload your images by adding them to the preload array in the store (index.js) -->
      <img :src="`${assetPath}lockup-overlays/intro--left.png`" alt="">
    </div>
    <div class="question-overlay question-overlay--top">
      <!-- <img :src="`${assetPath}lockup-overlays/quiz_intro-overlay--top@2x.png`" alt=""> -->
    </div>
    <transition name="fade">
      <div :class="{ 'transitioned-in': initialized }">
        <div class="svg-wrapper">
          <FindMyGrind class="find-your-grind" />
        </div>
        <div class="svg-wrapper">
          <FindMyGrind class="find-your-grind--mobile" />
        </div>
        <p class="intro-text">
          <!-- <span>By answering 6 simple questions,</span> we’ll help uncover your office coffee style and recommend solutions that fit your unique needs. -->
          Answer 6 questions and get tailored recommendations and a helpful office coffee kit.
        </p>
        <div class="start-button">
          <button type="button" class="button button--green" @click="startQuiz">
            Take Quiz
          </button>
        </div>
      </div>
    </transition>
    <div class="question-overlay question-overlay--right">
      <img :src="`${assetPath}lockup-overlays/intro--right.png`" alt="">
    </div>
    <div class="question-overlay question-overlay--bottom">
      <!-- <img :src="`${assetPath}lockup-overlays/quiz_intro-overlay--bottom@2x.png`" alt=""> -->
    </div>
    <div class="accessible-text">
      <p>The Find My Grind Quiz: Answer 6 questions and get tailored recommendations and a helpful office coffee kit.</p>
    </div>
  </div>
</template>

<script>
import zenscroll from 'zenscroll';
import { next } from './../../mixins/next.js'
import { assetPath } from './../../mixins/assetPath.js'

// import FindYourGrind from '@/assets/find-your-grind.svg'
// import FindYourGrindMobile from '@/assets/find-your-grind--mobile.svg'
import FindMyGrind from '@/assets/find-my-grind.svg'

export default {
  name: "Intro",
  components: {
    // FindYourGrind,
    // FindYourGrindMobile
    FindMyGrind
  },
  props: {
    initialized: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    startQuiz() {
      // eslint-disable-next-line
      if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: 'OCS Engagement',
          eventAction: 'click',
          eventLabel: 'Take Quiz',
        });
      }
      this.next('intro')
      zenscroll.to(document.querySelector('body'), 500)
    }
  },
  mixins: [next, assetPath]
}
</script>

<style lang="scss">

.find-your-grind--mobile {
  @media screen and (min-width: 769px) {
    display: none;
  }
}
.find-your-grind {
  display: none;
  @media screen and (min-width: 769px) {
    display: block;
  }
}

.question--quiz-intro {
  width: 100%;
  .svg-wrapper {
    width: 89%;
    position: relative;
    margin-bottom: 1em;
    /* top: -6vw; */
  }
  .question-overlay--left {
    z-index: map-get($z, 1);
    width: 48%;
  }
  .question-overlay--right {
    z-index: map-get($z, 1);
    width: 47%;
  }
  .question-overlay--top {
    /* top: -2vw; */
  }
  .question-overlay--bottom {
    /* bottom: -2vw; */
  }
  @include breakpoint(medium up) {
    .svg-wrapper {
      /* top: -4vw; */
    }
    .question-overlay--top {
      top: 0;
    }
    .question-overlay--bottom {
      bottom: 0;
    }
  }
  @include breakpoint(large) {
    .svg-wrapper {
      width: 40%;
      margin-bottom: 1.5em;
    }
  }
  @include breakpoint (xlarge) {
    .svg-wrapper {
      margin-bottom: 2em;
    }
  }
}
.start-button {
  /* position: absolute; */
  /* left: 0; */
  /* right: 0; */
  /* bottom: 6%; */
  margin: 0 auto;
  /* max-width: 140px; */
  display: flex;
  justify-content: center;
  /* button {
    @include button-style;
  } */
  @include breakpoint(medium) {
    // max-width: 200px;
    /* max-width: 240px; */
  }
  @include breakpoint(large) {
    // width: 100px;
    /* bottom: 2.3%; */
    /* left: calc(50% - 142px); */
    margin: 0;
    button {
      width: 13vw; // proto
    }
  }
  @include breakpoint(xlarge) {
    /* bottom: 2.75%; */
    /* max-width: 30%; */
    /* left: 32.5%; */
    // right: 50%;
  }
}

.intro-text {
  font-size: 1em;
  margin: 0 auto;
  padding: 0 1em;
  position: relative;
  /* top: -8vw; */
  font-weight: 600;
  text-align: center;
  color: $blue;
  z-index: map-get($z, 2);
  span {
    display: block;
    text-transform: uppercase;
  }
  @include breakpoint(medium) {
    /* top: -2vw; */
    max-width: 600px;
    margin: 1em auto;
  }
  @include breakpoint(large) {
    /* display: none; */
    font-size: 1.2em;
    padding: 0 2em;
  }
}

</style>